import { gql, TypedDocumentNode } from "@apollo/client";

import { AiIntegration, MutationAiIntegrationToggleArgs } from "types/generated";

type ToggleAiIntegrationData = {
  aiIntegrationToggle: Pick<AiIntegration, "id" | "enabled">;
};

export const TOGGLE_AI_INTEGRATION: TypedDocumentNode<
  ToggleAiIntegrationData,
  MutationAiIntegrationToggleArgs
> = gql`
  mutation ToggleAiIntegration($id: ID!, $enabled: Boolean!) {
    aiIntegrationToggle(id: $id, enabled: $enabled) {
      id
      enabled
    }
  }
`;
